package pl.decks.personal.pages.ievp.sections.lastyears

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.times


@Composable
fun LastYearsSectionContent(sectionProgress: Float) {
    val bufferSegments = 1.5f
    val revealSegments = ExuraStoryParagraphs.entries.size
    val totalSegments = revealSegments + bufferSegments

    val appearingSegments = 2
    val disappearingSegments = 4
    val totalVisibles = appearingSegments + disappearingSegments + 1

    val segSize = 1f / totalSegments
    Box(
        modifier = LastYearsSectionStylesheet.Section.toModifier()
            .height(totalSegments * LastYearsSectionStylesheet.Vars.segmentHeight.value())
            .flexShrink(0),
    ) {
        Box(
            modifier = LastYearsSectionStylesheet.StickyProgress.toModifier().flexShrink(0),
            contentAlignment = Alignment.Center,
        ) {
            Box(
                modifier = LastYearsSectionStylesheet.RollingStory.toModifier()
                    .height(totalVisibles * LastYearsSectionStylesheet.Vars.paragraphMaxHeight.value()),
                contentAlignment = Alignment.Center,
            ) {
                ExuraStoryParagraphs.entries.forEach { par ->
                    LastYearsParagraph(
                        paragraphProgress = (sectionProgress - par.ordinal.plus(bufferSegments) * segSize) / segSize,
                        appearingSegments = appearingSegments,
                        disappearingSegments = disappearingSegments,
                    ) {
                        par.content()
                    }
                }
            }
        }
    }
}

@Composable
private fun LastYearsParagraph(
    paragraphProgress: Float,
    appearingSegments: Int,
    disappearingSegments: Int,
    content: @Composable () -> Unit,
) {
    val linearProgression = when (paragraphProgress) {
        in -1f * appearingSegments..0f -> (paragraphProgress + appearingSegments) / appearingSegments
        in 0f..1f -> 1f
        in 1f..disappearingSegments + 1f -> 1f - (paragraphProgress - 1f) / disappearingSegments
        else -> 0f
    }
    val scale = 1f - (1f - linearProgression) * 0.5f
    Box(
        modifier = LastYearsSectionStylesheet.Paragraph.Container.toModifier()
            .opacity(linearProgression)
            .scale(scale)
            .translateY(-1 * paragraphProgress * LastYearsSectionStylesheet.Vars.paragraphMaxHeight.value())
            .thenIf(paragraphProgress in 0f .. 1f) { LastYearsSectionStylesheet.Paragraph.Current.toModifier() },
        contentAlignment = Alignment.CenterStart,
    ) {
        content()
    }
}

